/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './gynaec-checklist.reducer';

export const GynaecChecklistDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const gynaecChecklistEntity = useAppSelector(state => state.gynaecChecklist.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="gynaecChecklistDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.gynaecChecklist.detail.title">GynaecChecklist</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.id">Id</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.id}</dd>
          <dt>
            <span id="motherAntibiotics">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.motherAntibiotics">Mother Antibiotics</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.motherAntibiotics ? 'true' : 'false'}</dd>
          <dt>
            <span id="mChills">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.mChills">M Chills</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.mChills ? 'true' : 'false'}</dd>
          <dt>
            <span id="mFsvd">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.mFsvd">M Fsvd</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.mFsvd ? 'true' : 'false'}</dd>
          <dt>
            <span id="mLat">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.mLat">M Lat</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.mLat ? 'true' : 'false'}</dd>
          <dt>
            <span id="mLateRuptureOfMembranes">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.mLateRuptureOfMembranes">M Late Rupture Of Membranes</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.mLateRuptureOfMembranes ? 'true' : 'false'}</dd>
          <dt>
            <span id="mDelayedLabour">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.mDelayedLabour">M Delayed Labour</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.mDelayedLabour ? 'true' : 'false'}</dd>
          <dt>
            <span id="bAntibiotics">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bAntibiotics">B Antibiotics</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.bAntibiotics ? 'true' : 'false'}</dd>
          <dt>
            <span id="bAbnormalBreathing">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bAbnormalBreathing">B Abnormal Breathing</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.bAbnormalBreathing ? 'true' : 'false'}</dd>
          <dt>
            <span id="bChestGrunting">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bChestGrunting">B Chest Grunting</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.bChestGrunting ? 'true' : 'false'}</dd>
          <dt>
            <span id="bConvulsions">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bConvulsions">B Convulsions</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.bConvulsions ? 'true' : 'false'}</dd>
          <dt>
            <span id="bLooksSick">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bLooksSick">B Looks Sick</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.bLooksSick ? 'true' : 'false'}</dd>
          <dt>
            <span id="bTooCold">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bTooCold">B Too Cold</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.bTooCold ? 'true' : 'false'}</dd>
          <dt>
            <span id="bTooHot">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bTooHot">B Too Hot</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.bTooHot ? 'true' : 'false'}</dd>
          <dt>
            <span id="bStoppedFeeding">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bStoppedFeeding">B Stopped Feeding</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.bStoppedFeeding ? 'true' : 'false'}</dd>
          <dt>
            <span id="bExcessiveCrying">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bExcessiveCrying">B Excessive Crying</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.bExcessiveCrying ? 'true' : 'false'}</dd>
          <dt>
            <span id="bUmblicalRedness">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bUmblicalRedness">B Umblical Redness</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.bUmblicalRedness ? 'true' : 'false'}</dd>
          <dt>
            <span id="mBleedingControlled">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.mBleedingControlled">M Bleeding Controlled</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.mBleedingControlled ? 'true' : 'false'}</dd>
          <dt>
            <span id="bFeedingNormal">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bFeedingNormal">B Feeding Normal</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.bFeedingNormal ? 'true' : 'false'}</dd>
          <dt>
            <span id="bNotes">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.bNotes">B Notes</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.bNotes}</dd>
          <dt>
            <span id="mNotes">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.mNotes">M Notes</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.mNotes}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.active">Active</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.gynaecChecklist.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{gynaecChecklistEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.gynaecChecklist.patient">Patient</Translate>
          </dt>
          <dd>{gynaecChecklistEntity.patient ? gynaecChecklistEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.gynaecChecklist.incident">Incident</Translate>
          </dt>
          <dd>{gynaecChecklistEntity.incident ? gynaecChecklistEntity.incident.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/gynaec-checklist" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/gynaec-checklist/${gynaecChecklistEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default GynaecChecklistDetail;
